// extracted by mini-css-extract-plugin
export default {"container":"MO-z","topReviewHeading":"NO-z","criticalReview":"OO-z","favorableReview":"PO-z","vsSeparator":"QO-z"};